module.exports = __webpack_public_path__ + "media/images/diversity-hero-2-8dbe120f1dc05902f931ebd1468cd6ff.png";